import SideModal from "components/SideModal";
import { useTranslation } from "contexts/i18nContext";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useState } from "react";
import {
  editAppeal,
  editComplaint,
} from "services/prosecutorDecipilineService";
import { Appeal, Complaints } from "types";
import { LoadingIcon } from "utils/constant";
import {
  APPEAL_FEEDBACK_TYPE,
  APPEAL_STATUS,
  COMPLIANT_STATUS,
} from "utils/constantValues";
import "../styles/AddEvidenceModal.css";

interface FeedbackModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  complaintData: Complaints;
  appealData: Appeal;
  onRefresh: any;
}

export default function AddAppealFeedbackModal({
  isOpen,
  setIsOpen,
  complaintData,
  appealData,
  onRefresh,
}: FeedbackModalProps) {
  // const { user } = useAuth();
  const { t } = useTranslation();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  // const [adminUnitData, setAdminUnitData] = useState<AdminUnit>();
  // const [error, setError] = useState<string | null>(null);
  const [formState, setFormState] = useState<Appeal>({
    feedback_on_memorandum: "",
    appeal_status: APPEAL_FEEDBACK_TYPE.APPROVED,
  });

  // useEffect(() => {
  //   const loadAdminUnitDetail = async () => {
  //     try {
  //       const adminUnitDetail = await fetchAdminUnitDetail(
  //         user?.admin_unit,
  //         user?.access
  //       );
  //       setAdminUnitData(adminUnitDetail);

  //       setError("");
  //     } catch (err) {
  //       setError("Failed to Admin Unit Detail");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   loadAdminUnitDetail();
  // }, [user]);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!appealData) return;

    const data = {
      appeal_type: appealData?.appeal_type,
      admin_unit_id:
        //   adminUnitData?.hierarchy_level?.name === HIERARCHY_LEVELS.ZONAL
        //     ? adminUnitData?.parent_unit :
        complaintData?.admin_unit_id,
      memorandum_summary: appealData?.memorandum_summary,
      userid_requesting_prosecutor: appealData?.userid_requesting_prosecutor,
      requesting_prosecutor: appealData?.requesting_prosecutor,
      assigned_prosecutor: complaintData?.user_id_accused_prosecutor_name || "",
      user_id_assigned_prosecutor:
        complaintData?.user_id_accused_prosecutor_name || "",
      accused_prosecutor_name: complaintData?.accused_prosecutor_name || "",
      user_id_accused_prosecutor_name:
        complaintData?.user_id_accused_prosecutor_name || "",
      accused_prosecutor_org_id: complaintData?.accused_prosecutor_org_id || "",
      accused_prosecutor_admin_unit_id:
        complaintData?.accused_prosecutor_admin_unit_id || "",
      org_id: complaintData?.org_id || "",
      feedback_on_memorandum: formState.feedback_on_memorandum,
      appeal_feedback_status: formState.appeal_status,
      appeal_status:
        formState.appeal_status === APPEAL_FEEDBACK_TYPE.APPROVED
          ? APPEAL_STATUS.APPROVED
          : APPEAL_STATUS.REVISION_REQUIRED,
      discipline_case: appealData?.discipline_case || null,
    };
    const appeal_id = appealData?.id || "";
    const isFormData = false;

    setLoading(true);
    try {
      const resData = await editAppeal(data, appeal_id, isFormData);

      if (
        resData &&
        formState.appeal_status === APPEAL_FEEDBACK_TYPE.APPROVED
      ) {
        await editComplaint({
          ...complaintData,
          has_appeal: true,
          status: COMPLIANT_STATUS.APPEALED,
          is_final_decison_given: true,
        });
      }

      onRefresh();
      setIsOpen(false);
      showToast(t("successfullyCreated"), "success");

      setFormState({
        feedback_on_memorandum: "",
        appeal_status: APPEAL_STATUS.APPROVED,
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t("addMemorandumFeedback")}
    >
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          <div className="mb-4">
            <label className="text-sm font-medium text-gray-700 mb-1 block">
              {t("feedbackType")}
            </label>
            <select
              required
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
              name="appeal_status"
              value={formState.appeal_status ?? ""}
              onChange={handleChange}
            >
              {Object.values(APPEAL_FEEDBACK_TYPE)?.map((list) => (
                <option key={list} value={list}>
                  {list}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("feedbackOnMemorandum")}
            </label>
            <textarea
              required
              rows={7}
              name="feedback_on_memorandum"
              value={formState.feedback_on_memorandum}
              onChange={handleChange}
              placeholder={t("detailsHere")}
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
            />
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              {t("submitting")}
            </div>
          ) : (
            t("addFeedback")
          )}
        </button>
      </form>
    </SideModal>
  );
}
